import React, { useEffect } from 'react';

const Product1 = () => {
  // Declare the images array within the component
  const images = [
    "https://winstartek.com.tw/wp-content/uploads/2020/11/%E4%B8%8D%E7%B9%94003.jpg", // Replace with actual paths
    "https://winstartek.com.tw/wp-content/uploads/2020/11/Nonwoven02-1030x773.jpg",
    "https://winstartek.com.tw/wp-content/uploads/2020/11/Textile-%E5%88%87%E5%89%B2.jpg",
    "https://winstartek.com.tw/wp-content/uploads/2020/11/%E8%A1%80%E7%B3%96%E8%A9%A6%E7%B4%99-4.png",
    "https://winstartek.com.tw/wp-content/uploads/2020/11/%E9%87%91%E5%B1%AC001.jpg",
  ];

  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-10 bg-black text-white">
      {/* Company Name at the Top */}
      <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black animate-slide-in">
        Winstar Technology Co., Ltd.
      </h1>

      <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black animate-slide-in leading-snug">
        Winstar Technology
      </h1>

      <div className="space-y-12">

        {/* Company Overview Section */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://winstartek.com.tw/wp-content/uploads/2020/12/metal.jpg"
              alt="Company Overview"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Company Overview
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              Winstar Technology Co., Ltd., established in 1981 with HQ in New Taipei City, pioneered in
              professional Automatic Optical Inspection (AOI) manufacturing in Taiwan. It owns core technology that
              achieves high performance in digital image recognition, backed by over 44 years of product inspection
              technology and experience. Winstar elevates capacity and provides stringent inspection for various products.
            </p>
          </div>
        </section>

        {/* Defect Inspection Systems Section */}
        <section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="/defects.jpg"
              alt="Defect Inspection Systems"
              className="w-400 h-400 rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Defect Inspection Systems
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              The defect inspection systems developed by Winstar for Roll to Roll and sheet inspection cover multiple
              industries, including textile, fiber, copper foil, PCB, flexible board, non-woven fabrics, steel, thin film,
              optics, panels, and paper. These systems are widely applied across different processes, with customized services
              available for professional technologies.
            </p>
          </div>
        </section>

        {/* Industries and Applications Section */}
        <section className="text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Industries and Applications We Serve
          </h3>
          <ul className="list-disc list-inside text-lg space-y-4 transition-all duration-300 hover:text-gray-300">
            <li><strong>PCB and Flexible Board:</strong> AOI</li>
            <li><strong>Copper Foil/Copper Foil Substrate:</strong> Surface defect inspection system/pinhole inspection</li>
            <li><strong>Photoelectric Panel:</strong> Breakage inspection machine/ITO coating inspection</li>
            <li><strong>Biomedical Industry:</strong> Blood glucose strip printing/dispensing inspection systems/biomedical chip inspection</li>
            <li><strong>Textile:</strong> Automatic fabric inspection machines/smart fabric inspection machines/AI fabric inspection machines</li>
            <li><strong>Fiber:</strong> Stain inspection/defect inspection</li>
            <li><strong>Thin Film:</strong> Pinhole inspection/stain inspection/foreign matter inspection/crystallite inspection</li>
            <li><strong>Non-Woven Fabrics:</strong> Stain inspection/defect inspection/CCD metal inspection</li>
            <li><strong>Steel:</strong> Roller inspection/surface inspection</li>
            <li><strong>Paper Industry:</strong> Breakage inspection/stain inspection/fragment inspection</li>
          </ul>
        </section>

        {/* Image Section with Hover Animation */}
        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          <h3 className="text-3xl font-semibold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black text-center">
            Our Technology in Action
          </h3>
          {images.map((image, index) => (
            <div
              key={index}
              className="relative group rounded-lg overflow-hidden"
            >
              <img
                src={image}
                alt={`Technology ${index + 1}`}
                className="w-400 h-400 transform transition duration-500 group-hover:scale-110 group-hover:opacity-80"
              />
              <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-xl font-semibold"></span>
              </div>
            </div>
          ))}
        </section>

        {/* Contact Us Section */}
        <section className="mt-12 text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Contact Us
          </h3>
          <p className="text-lg">
            For more information about our products and services, please contact us at:- 
            <a href="mailto: rambomble@alphaq.co.in" className="text-blue-500 hover:text-blue-700 transition-colors duration-300">
             rambomble@alphaq.co.in
            </a>
          </p>
        </section>

      </div>
    </div>
  );
};

export default Product1;
